import {
  jb_globe_icon_css_default
} from "./chunk.SUTHK24A.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.IIVCI7D3.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-globe-icon/jb-globe-icon.ts
var JbGlobeIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Frame=04">
          <path
            id="line bottom"
            d="M4 17H20"
            stroke="currentColor"
          />
          <path
            id="aquator"
            d="M2 12L22 12"
            stroke="currentColor"
          />
          <path
            id="line top"
            d="M4 7.5H20"
            stroke="currentColor"
          />
          <circle
            id="outside"
            cx="12"
            cy="12"
            r="9.5"
            stroke="currentColor"
          />
          <path
            id="meridian_2"
            d="M16.5 12C16.5 14.7006 15.9516 17.1209 15.0883 18.8475C14.2101 20.604 13.0893 21.5 12 21.5C10.9107 21.5 9.78993 20.604 8.91168 18.8475C8.04839 17.1209 7.5 14.7006 7.5 12C7.5 9.29937 8.04839 6.87912 8.91168 5.15254C9.78993 3.39605 10.9107 2.5 12 2.5C13.0893 2.5 14.2101 3.39605 15.0883 5.15254C15.9516 6.87912 16.5 9.29937 16.5 12Z"
            stroke="currentColor"
          />
          <circle
            id="meridian"
            cx="12"
            cy="12"
            r="9.5"
            stroke="currentColor"
          />
        </g>
      </svg>
      <slot></slot>
    `;
  }
};
JbGlobeIcon.styles = [reset_css_default, jb_globe_icon_css_default];
JbGlobeIcon = __decorateClass([
  customElement("jb-globe-icon")
], JbGlobeIcon);

export {
  JbGlobeIcon
};
